import { ListItem } from "@mui/material";
import { FC } from "react";
import {
  NavigationIcon,
  NavigationItemButton,
  NavigationListItemContent,
} from "@/components/navigation/navigationItems";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import styles from "@/components/navigation/adminRoutes.module.css";
import "@/components/navigation/navigationBar.css";
import GenericButton from "@/components/forms/inputs/button/genericButton";

interface GenericExpandableNavigationListItemProps {
  drawerOpen: boolean;
  handleSubrouteOpen: (routeId: any) => void;
  subRouteOpen: any;
  listItemLabel: string;
  listItemIconName: NavigationIcon;
  subRouteKey: string;
}

const GenericExpandableNavigationListItem: FC<
  GenericExpandableNavigationListItemProps
> = ({
  drawerOpen,
  handleSubrouteOpen,
  subRouteOpen,
  listItemLabel,
  listItemIconName,
  subRouteKey,
}) => {
  return (
    <ListItem
      disablePadding
      className={drawerOpen ? "navigationItemOpen" : "navigationItem"}
    >
      <NavigationItemButton
        drawerOpen={drawerOpen}
        onClick={() => handleSubrouteOpen(subRouteKey)}
        pr={drawerOpen ? 1 : 0}
      >
        <NavigationListItemContent
          drawerOpen={drawerOpen}
          primaryText={listItemLabel}
          icon={listItemIconName}
        />
        {drawerOpen && !subRouteOpen[subRouteKey] && (
          <GenericButton
            variant="icon"
            color="iconBase"
            className={styles.iconButtonStyles}
          >
            <ExpandMore />
          </GenericButton>
        )}
        {drawerOpen && subRouteOpen[subRouteKey] && (
          <GenericButton
            variant="icon"
            color="iconBase"
            className={styles.iconButtonStyles}
          >
            <ExpandLess />
          </GenericButton>
        )}
      </NavigationItemButton>
    </ListItem>
  );
};

export default GenericExpandableNavigationListItem;
